module.exports = __webpack_public_path__ + "static/media/coronavirus.c9037e07.svg";